import { useSelector } from "react-redux";
import { getUserType } from "@/helpers/common";
import { USER_TYPE_AGENT } from "@/constants/common";
import { useCurrentWebsite } from "./useCurrentWebsite";
import { getLocalStorage } from "@/helpers/common";
import { USER_INFO_KEY } from "@/constants/common";

// Phoenix metro area cities - agents in these locations have full access on Gitcha
const PHOENIX_METRO_CITIES = [
  "phoenix",
  "scottsdale",
  "tempe",
  "mesa",
  "chandler",
  "gilbert",
  "glendale",
  "peoria",
  "surprise",
  "goodyear",
  "avondale",
  "buckeye",
  "casa grande",
  "fountain hills",
  "litchfield park",
  "maricopa",
  "queen creek",
  "san tan valley",
  "cave creek",
  "carefree",
  "paradise valley",
  "tolleson",
  "el mirage",
  "apache junction",
  "guadalupe",
  "gila bend",
  "wickenburg",
  "youngtown",
  "sun city",
  "sun city west",
  "anthem"
];

const isPhoenixMetroLocation = (location) => {
  if (!location) return false;
  const lowerLocation = location.toLowerCase();
  // Check for AZ state
  if (!lowerLocation.includes("az") && !lowerLocation.includes("arizona")) return false;
  // Check if city matches any Phoenix metro city
  return PHOENIX_METRO_CITIES.some((city) => lowerLocation.includes(city));
};

/**
 * Determines if an agent on the Gitcha website should be restricted.
 * Agents are NOT restricted (full BLS-like access) if:
 *   - They have no MLS associated (legacy agent), OR
 *   - Their profile location is in the Phoenix metro area
 * Agents ARE restricted if:
 *   - They have an MLS associated AND are not in Phoenix
 */
const useAgentGitchaRestrictions = () => {
  const isAgent = getUserType() === USER_TYPE_AGENT;
  const { isGitchaDefaultWebsite } = useCurrentWebsite();

  const sessionData = getLocalStorage(USER_INFO_KEY);
  const mls = sessionData?.userInfo?.mls;
  const location = sessionData?.userInfo?.location;

  const isLegacyAgent = !mls;
  const isPhoenixAgent = isPhoenixMetroLocation(location);

  // Agent should be restricted on Gitcha only if they have MLS AND are not in Phoenix
  const shouldRestrictAgent = isAgent && isGitchaDefaultWebsite && !isLegacyAgent && !isPhoenixAgent;

  return {
    shouldRestrictAgent,
    isAgent,
    isGitchaDefaultWebsite,
  };
};

export default useAgentGitchaRestrictions;
